var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.83 68.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.37,68.78A34.39,34.39,0,1,1,68.83,34.39,34.24,34.24,0,0,1,34.37,68.78ZM66.21,34.43A31.8,31.8,0,1,0,34.28,66.26,31.85,31.85,0,0,0,66.21,34.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.47,49.13a5.56,5.56,0,0,1,5-2.46c2.31-.05,4.64.09,7,0,7.81-.37,15.61-.82,23.42-1.21a18.86,18.86,0,0,1,2.64.26c-.92,1.88-2.35,2.15-3.75,2.32-2.93.34-5.87.72-8.82.83-7.66.28-15.32.42-23,.59A17.6,17.6,0,0,1,16.47,49.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.89,32a3.35,3.35,0,0,1-2.81,2.16,58.71,58.71,0,0,1-6.17.76c-8.62.37-17.24.65-25.86.93a26.44,26.44,0,0,1-3.19-.34,6,6,0,0,1,5-2.3c3.2,0,6.4.11,9.59,0C36.27,32.85,43.12,32.39,50,32,50.81,32,51.64,32,52.89,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.58,19.42a3.19,3.19,0,0,1-2.89,2.23,55.17,55.17,0,0,1-6.41.74c-8.93.32-17.86.55-26.79.79A9.56,9.56,0,0,1,14,23c.41-.57.6-1.08,1-1.33a8.25,8.25,0,0,1,4.6-1c5.19-.07,10.38-.08,15.56-.28,4.46-.18,8.92-.62,13.37-.91C49.38,19.37,50.31,19.42,51.58,19.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButton);
export default __webpack_public_path__ + "static/media/MenuButton.f774ced254fede1cf3cfcca98f7e90ec.svg";
export { ForwardRef as ReactComponent };